/* ==========================================================================
   PLIXOVA — Shopify theme scripts
   Direct conversion of the approved prototype (script.js).
   - Product gallery thumbnail switching + swipe
   - Bundle selector → variant radio (name="id") + price display sync
   - Sticky mobile Add to Cart
   Accordions and FAQ use native <details>/<summary>, so no JS is needed.
   Re-initializes cleanly inside the Shopify theme editor.
   ========================================================================== */

(function () {
  "use strict";

  if (window.__plxLoaded) return;
  window.__plxLoaded = true;

  function formatMoney(value) {
    return "$" + value.toFixed(2);
  }

  /* ------------------------------------------------------------------
     Product gallery — thumbnail switching + swipe on main image
  ------------------------------------------------------------------ */
  function initGallery(gallery) {
    if (gallery.dataset.plxBound) return;
    gallery.dataset.plxBound = "true";

    var mainImage = gallery.querySelector("[data-plx-gallery-main] img");
    var mainWrap = gallery.querySelector("[data-plx-gallery-main]");
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll("[data-plx-thumb]"));
    var activeIndex = 0;

    function showImage(index) {
      if (!mainImage || !thumbs.length) return;
      activeIndex = (index + thumbs.length) % thumbs.length;
      var thumb = thumbs[activeIndex];
      if (thumb.dataset.src) {
        mainImage.src = thumb.dataset.src;
        // The main image is rendered with a srcset; it MUST be replaced (or
        // removed) on swap, otherwise the browser keeps showing the original
        // image from the old srcset even though src changed.
        if (thumb.dataset.srcset) {
          mainImage.srcset = thumb.dataset.srcset;
        } else {
          mainImage.removeAttribute("srcset");
        }
        mainImage.alt = thumb.dataset.alt || "";
      }
      thumbs.forEach(function (t, i) {
        t.classList.toggle("is-active", i === activeIndex);
        t.setAttribute("aria-selected", i === activeIndex ? "true" : "false");
      });
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener("click", function () {
        showImage(i);
      });
    });

    if (mainWrap) {
      var touchStartX = null;

      mainWrap.addEventListener("touchstart", function (e) {
        touchStartX = e.changedTouches[0].clientX;
      }, { passive: true });

      mainWrap.addEventListener("touchend", function (e) {
        if (touchStartX === null) return;
        var delta = e.changedTouches[0].clientX - touchStartX;
        touchStartX = null;
        if (Math.abs(delta) < 40) return; // ignore taps / tiny drags
        showImage(delta < 0 ? activeIndex + 1 : activeIndex - 1);
      }, { passive: true });
    }
  }

  /* ------------------------------------------------------------------
     Bundle selector — variant binding.
     The hidden input[name="id"] ([data-plx-variant-input]) inside the
     product form is the single source of truth for the variant that is
     added to cart. Selecting a bundle row:
       1. updates the hidden id input to that row's real variant ID
       2. updates the displayed price / compare-at / savings badge
          (real variant prices in cents take priority; the block's
           display-text prices are the fallback)
       3. enables Add to Cart, or disables it only when the selected
          variant is actually unavailable
  ------------------------------------------------------------------ */
  function initBundles(section) {
    if (section.dataset.plxBundlesBound) return;
    section.dataset.plxBundlesBound = "true";

    var priceCurrent = section.querySelector("[data-plx-price-current]");
    var priceCompare = section.querySelector("[data-plx-price-compare]");
    var priceBadge = section.querySelector("[data-plx-price-badge]");
    var stickyPrice = section.querySelector("[data-plx-sticky-price]");
    var variantInput = section.querySelector("[data-plx-variant-input]");
    var atcButtons = section.querySelectorAll("[data-plx-atc]");

    function centsToNumber(value) {
      if (value === undefined || value === null || value === "") return NaN;
      var n = parseInt(value, 10);
      return isNaN(n) ? NaN : n / 100;
    }

    /* --- Live variant data (rendered by Liquid as JSON) --- */
    var variants = [];
    var variantsEl = section.querySelector("[data-plx-variants]");
    if (variantsEl) {
      try { variants = JSON.parse(variantsEl.textContent) || []; } catch (e) { variants = []; }
    }

    function normalizeTitle(t) {
      return String(t || "").replace(/,/g, "").replace(/\s+/g, " ").trim().toLowerCase();
    }

    function findVariantById(id) {
      id = parseInt(id, 10);
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].id === id) return variants[i];
      }
      return null;
    }

    function findVariantByTitle(title) {
      var norm = normalizeTitle(title);
      for (var i = 0; i < variants.length; i++) {
        if (normalizeTitle(variants[i].title) === norm || normalizeTitle(variants[i].option1) === norm) {
          return variants[i];
        }
      }
      return null;
    }

    /* Re-validate every bundle row against the live variant list.
       If a row carries a stale/unknown variant ID, re-match it by title
       (commas ignored: "Buy 3, Get 1 Free" matches "Buy 3 Get 1 Free")
       and refresh its data attributes + radio value from live data. */
    section.querySelectorAll(".plx-bundle").forEach(function (bundleEl) {
      if (!variants.length) return;
      var v = findVariantById(bundleEl.dataset.variantId);
      if (!v) {
        v = findVariantByTitle(bundleEl.dataset.matchTitle || bundleEl.dataset.variantTitle);
        if (v) bundleEl.dataset.plxRematched = "title";
      }
      if (v) {
        bundleEl.dataset.variantId = v.id;
        bundleEl.dataset.variantTitle = v.title;
        bundleEl.dataset.variantAvailable = String(v.available);
        if (typeof v.price === "number") bundleEl.dataset.variantPrice = v.price;
        bundleEl.dataset.variantComparePrice = typeof v.compare_at_price === "number" ? v.compare_at_price : "";
        var radio = bundleEl.querySelector(".plx-bundle__input");
        if (radio) radio.value = v.id;
      }
    });


    function updateFromBundle(bundleEl) {
      // Price: real variant price (cents) first, display-text fallback
      var price = centsToNumber(bundleEl.dataset.variantPrice);
      if (isNaN(price)) price = parseFloat(bundleEl.dataset.price);
      var compare = centsToNumber(bundleEl.dataset.variantComparePrice);
      if (isNaN(compare)) compare = parseFloat(bundleEl.dataset.compare);

      if (!isNaN(price)) {
        if (priceCurrent) priceCurrent.textContent = formatMoney(price);
        if (stickyPrice) stickyPrice.textContent = formatMoney(price);
      }

      var hasCompare = !isNaN(price) && !isNaN(compare) && compare > price;
      if (priceCompare) {
        priceCompare.textContent = hasCompare ? formatMoney(compare) : "";
        priceCompare.style.display = hasCompare ? "" : "none";
      }
      if (priceBadge) {
        priceBadge.textContent = hasCompare ? "Save " + Math.round((1 - price / compare) * 100) + "%" : "";
        priceBadge.style.display = hasCompare ? "" : "none";
      }

      // Variant binding: point the form's id input at this row's variant
      if (variantInput && bundleEl.dataset.variantId) {
        variantInput.value = bundleEl.dataset.variantId;
      }

      // Availability: disable Add to Cart ONLY when the variant is unavailable
      var available = bundleEl.dataset.variantAvailable !== "false";
      atcButtons.forEach(function (btn) {
        if (!btn.dataset.plxLabel) btn.dataset.plxLabel = btn.textContent.trim();
        btn.disabled = !available;
        btn.setAttribute("aria-disabled", String(!available));
        btn.textContent = available ? btn.dataset.plxLabel : (btn.dataset.soldoutLabel || "Sold Out");
      });
    }

    /* Submit guard: never let the form post a blank or unknown variant ID */
    var productForm = variantInput ? variantInput.closest("form") : null;
    if (productForm) {
      productForm.addEventListener("submit", function (e) {
        var id = variantInput.value;
        var v = variants.length ? findVariantById(id) : null;
        if (!id || (variants.length && !v)) {
          e.preventDefault();
          console.warn("[PLIXOVA] Blocked Add to Cart: form id input holds an invalid variant ID:", id, "Known variants:", variants);
          return;
        }
        if (v) {
          console.log("[PLIXOVA] Submitting variant:", v.id, "|", v.title, "| available:", v.available, "| price:", v.price);
        }
      });
    }

    var radios = Array.prototype.slice.call(section.querySelectorAll(".plx-bundle__input"));

    radios.forEach(function (input) {
      input.addEventListener("change", function () {
        updateFromBundle(input.closest(".plx-bundle"));
      });
    });

    // Initial selection: keep the server-rendered choice if it is available;
    // otherwise fall back to the first bundle row with an available variant.
    var checked = section.querySelector(".plx-bundle__input:checked");
    if (!checked || checked.closest(".plx-bundle").dataset.variantAvailable === "false") {
      for (var i = 0; i < radios.length; i++) {
        if (radios[i].closest(".plx-bundle").dataset.variantAvailable !== "false") {
          radios[i].checked = true;
          checked = radios[i];
          break;
        }
      }
    }
    if (checked) updateFromBundle(checked.closest(".plx-bundle"));
  }

  /* ------------------------------------------------------------------
     Sticky mobile Add to Cart — appears after the buy box scrolls
     out of view. Its button submits the real product form via the
     form="" attribute, so no extra cart logic is needed here.
  ------------------------------------------------------------------ */
  function initStickyAtc(section) {
    var stickyAtc = section.querySelector("[data-plx-sticky-atc]");
    var buybox = section.querySelector("[data-plx-buybox]");
    if (!stickyAtc || !buybox || stickyAtc.dataset.plxBound) return;
    stickyAtc.dataset.plxBound = "true";

    if ("IntersectionObserver" in window) {
      var observer = new IntersectionObserver(function (entries) {
        var visible = entries[0].isIntersecting;
        stickyAtc.classList.toggle("is-visible", !visible);
        stickyAtc.setAttribute("aria-hidden", visible ? "true" : "false");
      }, { rootMargin: "-80px 0px 0px 0px" });
      observer.observe(buybox);
    }
  }

  /* ------------------------------------------------------------------
     Init — on load and again when the theme editor reloads a section
  ------------------------------------------------------------------ */
  function initAll(root) {
    root = root || document;
    root.querySelectorAll("[data-plx-gallery]").forEach(initGallery);
    root.querySelectorAll("[data-plx-product-section]").forEach(function (section) {
      initBundles(section);
      initStickyAtc(section);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (e) {
    initAll(e.target);
  });
})();
